module.exports = __webpack_public_path__ + "static/gallery-3-f6d2f7ebd16abbf7ea066e36ca48e6a0.jpg";